<mat-toolbar color="primary" class="footer">
    <span class="left">
        <a href="https://construct-x.org/" target="_blank">ÜBER Construct-X</a>
        <!--<a href="https://www.bimswarm.de/newsletter-anmeldung" target="_blank">NEWSLETTER</a>
        <a href="https://www.bimswarm.de/produkttypen" target="_blank">Produkttypen</a> -->
        <!-- <a href="mailto:info@construct-x.org">KONTAKT</a> -->
    </span>

    <span class="right">
        <!-- <a routerLink="/privacy">DATENSCHUTZ</a>
        <a routerLink="/impressum">IMPRESSUM</a> -->
        <!-- <a routerLink="/agb">AGB</a>
         <a routerLink="/sitemap">Sitemap</a> -->
    </span>
</mat-toolbar>
